export class DocumentTypeModel {
  public documentTypeCode: string;
  public description: string;
  public appRefID: number;
  public docID: number;
}
